import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
var $t = Vue.prototype.$t;
// 表单校验
var baseRule = function baseRule(tip) {
  return [{
    required: true,
    message: tip || $t('90')
  }];
};
// 多选校验 这里的逻辑是选项必须存在
var customRule = function customRule() {
  return [{
    validator: function validator(_, value, cFn) {
      if (!value || !value.length) return cFn(new Error($t('cefb30a7')));
      var state = value.some(function (item) {
        return !item.label;
      });
      if (state) return cFn(new Error($t('c0f620b3')));
      return cFn();
    }
  }];
};

// 选项校验
var optionRule = function optionRule() {
  return [{
    validator: function validator(_, value, cFn) {
      if (!value || !value.length) return cFn(new Error($t('cefb30a7')));
      return cFn();
    }
  }];
};
export var rules = {
  name: baseRule(),
  startName: baseRule(),
  endName: baseRule(),
  longName: baseRule(),
  dateType: baseRule($t('221')),
  timeType: baseRule($t('221')),
  options: customRule(),
  fileType: optionRule(),
  maxUploadFiles: baseRule(),
  maxUploadSize: baseRule()
};